(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    updateCustomCardGalleries();

  const mobileCardGalleryMedia = window.matchMedia('(max-width: 749px)');

  function updateCustomCardGalleries() {
    document.querySelectorAll('.card-gallery').forEach((gallery) => {
      const slideshow = gallery.querySelector('slideshow-component');

      if (mobileCardGalleryMedia.matches) {
        if (gallery.hasAttribute('on:pointerenter')) {
          gallery.dataset.desktopPointerenter = gallery.getAttribute('on:pointerenter');
          gallery.removeAttribute('on:pointerenter');
        }

        if (gallery.hasAttribute('on:pointerleave')) {
          gallery.dataset.desktopPointerleave = gallery.getAttribute('on:pointerleave');
          gallery.removeAttribute('on:pointerleave');
        }

        if (slideshow && !slideshow.hasAttribute('disabled')) {
          slideshow.dataset.mobileDisabled = 'true';
          slideshow.setAttribute('disabled', 'true');
        }

        return;
      }

      if (gallery.dataset.desktopPointerenter) {
        gallery.setAttribute('on:pointerenter', gallery.dataset.desktopPointerenter);
        delete gallery.dataset.desktopPointerenter;
      }

      if (gallery.dataset.desktopPointerleave) {
        gallery.setAttribute('on:pointerleave', gallery.dataset.desktopPointerleave);
        delete gallery.dataset.desktopPointerleave;
      }

      if (slideshow?.dataset.mobileDisabled === 'true') {
        slideshow.removeAttribute('disabled');
        delete slideshow.dataset.mobileDisabled;
      }
    });
    
  }

  updateCustomCardGalleries();
  document.addEventListener('DOMContentLoaded', updateCustomCardGalleries, { once: true });
  document.addEventListener('shopify:section:load', updateCustomCardGalleries);
  mobileCardGalleryMedia.addEventListener('change', updateCustomCardGalleries);
  } catch(e) { console.error(e); }
})();

})();
